import axios from 'axios';
import { io } from 'socket.io-client';
import { config } from '../config/config';

class ChatService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
  }

  connect() {
    if (!config.features.enableChat) return;
    
    this.socket = io(config.api.websocketUrl, {
      transports: ['websocket']
    });

    this.socket.on('connect', () => {
      this.isConnected = true;
      console.log('Chat connected');
    });

    this.socket.on('disconnect', () => {
      this.isConnected = false;
      console.log('Chat disconnected');
    });

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.isConnected = false;
    }
  }

  async sendMessage(message, userId = "frontend-user") {
  try {
    console.log("📤 Sending message to backend:", config.api.chatUrl);

    const payload = {
      model: "askSRE",
      user: userId,
      messages: [
        { role: "user", content: message }
      ]
    };

    const response = await axios.post(config.api.chatUrl, payload, {
      headers: { "Content-Type": "application/json" }
    });

    console.log("✅ Raw backend response:", response.data);

    // Extract the actual answer safely
    const answer =
      response.data?.choices?.[0]?.message?.content?.trim() ||
      "⚠️ No valid response from backend.";

    console.log("💬 Final message to display:", answer);
    return { message: answer };

  } catch (error) {
    console.error("❌ Chat API error:", error);
    return { error: "Failed to send message to backend." };
  }
}



  onMessage(callback) {
    if (this.socket) {
      this.socket.on('message', callback);
    }
  }

  onTyping(callback) {
    if (this.socket) {
      this.socket.on('typing', callback);
    }
  }

  emitTyping(isTyping) {
    if (this.socket && this.isConnected) {
      this.socket.emit('typing', isTyping);
    }
  }
}

export const chatService = new ChatService();